module.exports = __webpack_public_path__ + "img/projects.b1036e35.svg";